exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-wrapper[data-v-13877386]{position:relative;height:100%;width:100%;min-width:1300px;overflow-x:auto}.fixed-header[data-v-13877386]{width:100%}.main-content[data-v-13877386]{height:calc(100% - 50px);display:-webkit-box;display:-ms-flexbox;display:flex;position:relative}.main-content .sidebar-container[data-v-13877386]{-webkit-transition:width 0.28s;transition:width 0.28s;width:210px;background-color:#fff;font-size:0;overflow:hidden;-webkit-box-shadow:3px 2px 5px rgba(0,0,0,0.05);box-shadow:3px 2px 5px rgba(0,0,0,0.05)}.main-container[data-v-13877386]{width:calc(100% - 210px)}\n", ""]);

// exports
